import { Path, SVG } from '@wordpress/primitives';

export default (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style={ { fill: "none" } } stroke="currentColor" strokeWidth="1.5">
		<Path d="M11.5 18.75H5.25V12.5M5.25 18.75L18.75 5.25M18.75 11.5V5.25H12.5" />
	</SVG>
);
